import utils from '@/components/tools/utils'

export default {

  setHost (state, host) {
    state.host = host
  },

  setSnackbar (state, value) {
    state.snackbar = value
  },

  setHideNavbar (state, slug) {
    state.hideNavbar[slug] = true
  },

  setHideFooter (state, slug) {
    state.hideFooter[slug] = true
  },

  showSnackbar (state, { text, color, timeout, vertical }) {
    if (color) {
      state.snackbarColor = color
    }
    if (timeout) {
      state.timeout = timeout
    }

    state.snackbarText = text
    state.snackbar = true
    state.isSnackbarVertical = vertical ?? false
  },

  resetTimeout (state) {
    state.timeout = 10000
  },

  showSnackbarMaybe (state, type) {
    if (type === utils.Cm24SnackbarType.MERCHANT_COMPLETE_AND_EMAIL_VERIFIED) {
      state.snackbarText = 'Vielen Dank für die Übermittlung Ihrer Firmendaten. Wir prüfen Ihre Angaben und schalten Ihr Nutzerkonto in Kürze frei.'
      state.snackbar = true
    } else if (type === utils.Cm24SnackbarType.MERCHANT_COMPLETE_BUT_EMAIL_NOT_VERIFIED) {
      state.snackbarText = 'Vielen Dank für die Übermittlung Ihrer Firmendaten. Verifizieren Sie bitte noch Ihre Email Adresse. Wir haben Ihnen hierzu eine gesonderte Email gesendet. Anschließend prüfen wir Ihre Angaben und schalten Ihr Nutzerkonto in Kürze frei.'
      state.snackbar = true
    } else if (type === utils.Cm24SnackbarType.PRIVATE_COMPLETE_AND_EMAIL_VERIFIED || type === utils.Cm24SnackbarType.PRIVATE_COMPLETE_AND_EMAIL_VERIFIED) {
      state.snackbarText = 'Vielen Dank für die Übermittlung Ihrer Daten. Ihr Nutzerkonto ist nun freigeschaltet.'
      state.snackbar = true
    } else if (type === utils.Cm24SnackbarType.PRIVATE_COMPLETE_BUT_EMAIL_NOT_VERIFIED || type === utils.Cm24SnackbarType.COMMERCIAL_COMPLETE_BUT_EMAIL_NOT_VERIFIED) {
      state.snackbarText = 'Vielen Dank für die Übermittlung Ihrer Daten. Verifizieren Sie bitte noch Ihre Email Adresse. Wir haben Ihnen hierzu eine gesonderte Email gesendet. Anschließend schalten wir Ihr Nutzerkonto frei.'
      state.snackbar = true
    } else if (type === utils.Cm24SnackbarType.IMPORT_FROM_MOBILE_DE_FAILED) {
      state.snackbarText = 'Import gescheitert, bitte versuchen Sie es ein weiteres Mal.'
      state.snackbar = true
    } else if (type === utils.Cm24SnackbarType.IMPORT_FROM_SYSCARA_FAILED) {
      state.snackbarText = 'Import gescheitert, bitte versuchen Sie es ein weiteres Mal.'
      state.snackbar = true
    }
  },

  setDifferenceToServerTime (state, { serverTime, responseTime }) {
    const now = Date.now()
    state.differenceToServerTime = now - (serverTime + Math.ceil(responseTime / 2))
  }

}
